
import React from 'react';
import { Link } from 'react-router-dom';
import useMediaQuery from '../../hooks/useMediaQuery';

import styles from './Header.module.css';

const MusicHeader = () => {
  const mobileNavigationDialogRef = React.useRef(null);
  const isMobile = useMediaQuery("(max-width: 768px)");

  const handleNavClick = async (linkType) => {
    mobileNavigationDialogRef?.current?.close();

    const { logAnalyticsEvent } = await import('../../utils/analyticsUtils');
    logAnalyticsEvent('nav_link_click', {
      link_type: linkType
    });
  };

  const handleMenuOpen = () => {
    mobileNavigationDialogRef?.current?.showModal();
  };

  const handleMenuClose = () => {
    // Is null on first render
    mobileNavigationDialogRef?.current?.close();
  };

  if (!isMobile) return (
    <nav className={styles.headerContainer} aria-label="Primary">
      <ul className={styles.listContainer}>
        <li className={styles.topBarNavItem}><Link className={styles.navLink} to="/" onClick={() => handleNavClick('home')}>HOME</Link></li>

        <li className={`${styles.topBarNavItem} ${styles.pushRight}`}><Link className={styles.navLink} to="/about" onClick={() => handleNavClick('about')}>ABOUT</Link></li>
        <li className={styles.topBarNavItem}><Link className={styles.navLink} to="/commissions" onClick={() => handleNavClick('commissions')}>COMMISSION</Link></li>
        <li className={styles.topBarNavItem}><Link className={styles.navLink} to="/work" onClick={() => handleNavClick('work')}>WORK</Link></li>

      </ul>
    </nav>
  )

  return (
    <nav className={styles.headerContainer} aria-label="Primary">
      <ul className={styles.listContainer}>
        <li className={styles.topBarNavItem}>
          <Link to="/" onClick={() => handleNavClick('home')}>HOME</Link>
        </li>

        <li className={`${styles.topBarNavItem} ${styles.pushRight}`}>
          <button
            type="button"
            className={`iconButton ${styles.menuToggleButton}`}
            onClick={handleMenuOpen}
            aria-label="Open menu"
            aria-haspopup="dialog"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon lucide lucide-menu-icon lucide-menu" aria-hidden="true"><path d="M4 5h16" /><path d="M4 12h16" /><path d="M4 19h16" /></svg>
          </button>
        </li>
      </ul>

      <dialog ref={mobileNavigationDialogRef} id="popup-navigation-menu" aria-label="Popup navigation menu" className={styles.fullScreenModal}>
        <header>
          <button
            type="button"
            className={`iconButton ${styles.menuToggleButton}`}
            onClick={handleMenuClose}
            aria-label="Close menu"
            style={{ outline: "none" }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon lucide lucide-x-icon lucide-x" aria-hidden="true"><path d="M18 6 6 18" /><path d="m6 6 12 12" /></svg>
          </button>
        </header>

        <nav className={styles.modalBodyContainer}>
          <ul className={styles.mobileLinksContainer}>
            <li className={styles.dialogNavItem}>
              <Link className={styles.navLink} to="/about" onClick={() => handleNavClick('about')}>ABOUT</Link>
            </li>
            <li className={styles.dialogNavItem}>
              <Link className={styles.navLink} to="/commissions" onClick={() => handleNavClick('commissions')}>
                REQUEST A COMMISSION
              </Link>
            </li>
            <li className={styles.dialogNavItem}>
              <Link className={styles.navLink} to="/work" onClick={() => handleNavClick('work')}>
                BROWSE WORK
              </Link>
            </li>
            <li className={styles.dialogNavItem}>
              <Link className={styles.navLink} to="/contact" onClick={() => handleNavClick('work')}>
                CONTACT ME
              </Link>
            </li>
            <li className={styles.dialogNavItem}>
              <a className={styles.navLink} href="https://code.lawrenceluo.me/work" aria-label="Music Tech portfolio (opens in new tab)" target="_blank" rel="noopener noreferrer" onClick={() => handleNavClick('code from music')}>
                MUSIC TECH
              </a>
            </li>
          </ul>
        </nav>
      </dialog>
    </nav>
  )
}

export default MusicHeader;